import React, { useState } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';

// Helper function to generate the days of the month
const generateCalendar = (month, year) => {
  const firstDay = new Date(year, month, 1).getDay(); // Day of the week for the 1st
  const daysInMonth = new Date(year, month + 1, 0).getDate(); // Number of days in the month
  let days = [];
  const weeks = [];

    // Add the actual days of the month
    for (let i = 1; i <= (daysInMonth+firstDay); i++) {
        if (i <= firstDay)
            days.push(null);
        else
            days.push(i-firstDay);

        if (i % 7 === 0) {
           weeks.push(days)
           days = [];
        }
    }

    return weeks;
};

const Calendar = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);

  // Generate calendar for the current month and year
  const days = generateCalendar(currentMonth, currentYear);

  // Handle the change of month
  const goToPreviousMonth = () => {
    setCurrentMonth(currentMonth === 0 ? 11 : currentMonth - 1);
    setCurrentYear(currentMonth === 0 ? currentYear - 1 : currentYear);
  };

  const goToNextMonth = () => {
    setCurrentMonth(currentMonth === 11 ? 0 : currentMonth + 1);
    setCurrentYear(currentMonth === 11 ? currentYear + 1 : currentYear);
  };

  // Handle the day click
  const handleDayClick = (day) => {
    // Set the selected date
    const selectedDate = new Date(currentYear, currentMonth, day);
    setSelectedDate(selectedDate);
  };

  // Month names for display
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  return (
    <Container>
      <Card className="my-4">
        <Card.Body>
          <Row className="mb-3">
            <Col className="text-center">
              <Button variant="outline-secondary" onClick={goToPreviousMonth}>Prev</Button>
            </Col>
            <Col className="text-center">
              <h4>{monthNames[currentMonth]} {currentYear}</h4>
            </Col>
            <Col className="text-center">
              <Button variant="outline-secondary" onClick={goToNextMonth}>Next</Button>
            </Col>
          </Row>

          <Row xs={12} className='p-0 m-0 text-start'>
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => (
              <Col className='p-0 m-0' key={index}>
                <strong>{day}</strong>
              </Col>
            ))}
          </Row>

          <Row xs={12}>
            {days[0].map((day, index) => (
              day ? (
                <Col className='p-0 m-0 text-start' key={index}>
                  <Button 
                    variant="outline-primary" 
                    block
                    onClick={() => handleDayClick(day)}
                    active={selectedDate && selectedDate.getDate() === day && selectedDate.getMonth() === currentMonth && selectedDate.getFullYear() === currentYear}
                  >
                    {day}
                  </Button>
                </Col>
              ) : (
                <Col>
                    <div></div>
                </Col>
              )
            ))}
          </Row>

          <Row xs={12}>
            {days[1].map((day, index) => (
              day ? (
                <Col className='p-0 m-0 text-start' key={index}>
                  <Button 
                    variant="outline-primary" 
                    block
                    onClick={() => handleDayClick(day)}
                    active={selectedDate && selectedDate.getDate() === day && selectedDate.getMonth() === currentMonth && selectedDate.getFullYear() === currentYear}
                  >
                    {day}
                  </Button>
                </Col>
              ) : (
                <Col>
                    <div></div>
                </Col>
              )
            ))}
          </Row>

          {/* Display selected date */}
          {selectedDate && (
            <div className="mt-3">
              <h5>Selected Date: {selectedDate.toDateString()}</h5>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Calendar;
